import styled from 'styled-components';
import { Box } from '@mui/material';

export const ViewRequestWrapper = styled(Box)`
font-family: 'Noto Sans', sans-serif;
margin-top: 48px;
margin-bottom:150px;
.tabpannel{
    margin-top: 48px;
    button.Mui-selected{
    color: white;
    cursor: pointer;
    border-radius: 5px;
    background-color: #1B4A83;
        text-transform: capitalize;
    }
}
.quoteInput{
    display: flex;
    padding: 20px 0px 0px 20px;
    text-align: left;
    margin-bottom: 20px;
    flex-direction: row;
    align-items: center;
}
    h4{
        font-size:18px;
        margin: 0;
        color:#1B4A83;
        font-weight: 500;
            padding-left: 6px;
                padding-bottom: 6px;
    }
   
        
}
.ifapplicable{
    font-weight: 200!important;
    }
.quoteText{
    padding-left:14px;
    padding-right:10px;
}
.boxWrapper{
        border: 1px solid #1B4A83;
        background-color:#fff;
    border-radius: 0px 0px 5px 5px;
        border-top: 5px solid rgb(27, 74, 131);
        padding: 30px;
.boxContainer{
display: flex;


}
.detailWrapper{
        width: 100%;
        margin-top: 16px;
        gap: 1%;
   
    .otherDetail{
        width: 100%;
        h3{
                text-align: start;
            color: #1B4A83;
            font-size: 20px;
        }

    }    
}
.approvalDiscountContainer{
    display: flex;
    width: 100%;
    justify-content: space-between;
    .approval{
        
        h3{
            text-align: start;
            color: #1B4A83;
            font-size: 20px;
        }

    }

    .discount{  
        //flex-direction: row;
        h3{
            text-align: start;
            color: #1B4A83;
            font-size: 20px;
        }

    }
}

.quoteData{
    margin-top: 30px;
    .formdataContainer{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding: 34px 10px 0;
        width: 100%;
    
        .formdataFieldOne{
            width: 50%;
            padding-bottom: 30px;
            text-align: left;
            label{
                font-weight: 700;
                font-size:16px;
            }
        }
        .infoIcon {
            font-size: 18px;
            margin: -5px 5px;
            color: #1B4A83;
          }
        .formdataFieldTwo{
            width: 25%;
            padding-bottom: 30px;
            text-align: left;
            label{
                font-weight: 700;
                font-size:16px;
                padding-left:3px;
            }
        }
        .formdataFieldTwoThree{
            width: 33%;
            padding-bottom: 30px;
            text-align: left;
            label{
                font-weight: 700;
                font-size:16px;
                padding-left:3px;
            }
        }
        .formdataFieldThree{
            width: 37%;
            padding-bottom: 30px;
            text-align: left;
            label{
                font-weight: 700;
                font-size:16px;
            }
        }
        .formdataFieldFour{
            width: 25%;
            padding-bottom: 90px;
            text-align: left;
            label{
                font-weight: 700;
                font-size:16px;
            }
            .fileName {
                margin-top: 28px;
                flex: 1;
                text-decoration: underline;
                color: blue;
                text-overflow: ellipsis;
                cursor: pointer;
                overflow:hidden;
              }
        }
        .formdataFiedlTwoTwo {
            width: 75%;
            text-align: start;
            min-height: 175px;
        
            label {
              font-size: 16px;
              color: #080909;
              font-weight: 700;
              padding-left: 3px;
            }
            .infoIcon {
              font-size: 18px;
              margin: -5px 5px;
            }
            
          }
          .formInputTwoTwo {
            margin-top: 16px;
            width: 93%;
            background-color:rgb(228, 228, 228);
            font-size:14px;
            .MuiInputBase-input{
                height: 0.2375em;
                background-color: #E4E4E4;
                border-radius: 5px;
                font-weight: 600;
                font-size:14px;
            }
            .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {
                opacity: 1;
                -webkit-text-fill-color: rgba(0, 0, 0, 0.87);
            }
          }
        .formdataFieldFive{
            width: 100%;
            padding-bottom: 30px;
            text-align: left;
            label{
                font-weight: 700;
                font-size:16px;
            }
        }
        .formdataFieldSix{
            width: 33%;
            padding-bottom: 30px;
            text-align: left;
            label{
                font-weight: 700;
                font-size:16px;
            }
        }
        .formInput{
            width: 90%;
            margin-top: 28px;
            background-color:rgb(228, 228, 228);
            font-size:14px;
            .MuiInputBase-input{
                height: 0.2375em;
                background-color: #E4E4E4;
                border-radius: 5px;
                font-weight: 600;
                font-size:14px;
            }
            .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {
                opacity: 1;
                -webkit-text-fill-color: rgba(0, 0, 0, 0.87);
            }
        }
        .css-1sqnrkk-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {
            opacity: 1;
           -webkit-text-fill-color: rgba(0, 0, 0, 0.87);
        }
        .formInputTwo{
            width: 90%;
            margin-top: 10px;
            background-color:rgb(228, 228, 228);
            font-size:14px;
            .MuiInputBase-input{
                height: 0.2375em;
                background-color: #E4E4E4;
                border-radius: 5px;
                font-weight: 600;
                font-size:14px;
            }
            .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {
                opacity: 1;
                -webkit-text-fill-color: rgba(0, 0, 0, 0.87);
            }
        }
        .formInputThree{
            width: 95%;
            margin-top: 28px;
            background-color:rgb(228, 228, 228);
            font-size:14px;
            .MuiInputBase-input{
                height: 0.2375em;
                background-color: #E4E4E4;
                border-radius: 5px;
                font-weight: 600;
                font-size:14px;
            }
            .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {
                opacity: 1;
                -webkit-text-fill-color: rgba(0, 0, 0, 0.87);
            }
        }
        .formInputFour{
            width: 90%;
            margin-top: 48px;
            background-color:rgb(228, 228, 228);
            font-size:14px;
            .MuiInputBase-input{
                height: 0.2375em;
                background-color: #E4E4E4;
                border-radius: 5px;
                font-weight: 600;
                font-size:14px;
            }
            .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {
                opacity: 1;
                -webkit-text-fill-color: rgba(0, 0, 0, 0.87);
            }
        }
    }
}
.countryList{
    margin-top: 30px;
    .countryTable{
        padding: 30px;
         thead{
     background-color: #BDD0E9;
     tr{
         th{
             color: #000000;
             font-weight: 600;
         }
         .css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon {
            opacity: 1;
            color: #000000;
        }
         .MuiTableSortLabel-icon {
            opacity: 1;
            color: #000000;
            font-size:20px;
        }
     }
  }
  tbody{
                  border: 1px solid #1B4A83;
border-radius: 0px 0px 5px 5px;
border-bottom: 2px solid #1B4A83;
      td{
          text-align: start;
      }
  }
    }
}
.distribution{
    margin-top: 30px;
   
    .distributionTable{
        padding: 30px;
        .servicetable
     {
        minwidth:400px;
               thead{
     background-color: #BDD0E9;
     
     tr{
         th{
             color: #000000;
             font-weight: 600;
             width:20px;
             border-bottom: 1px solid #1B4A83;
         }
         .css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon {
            opacity: 1;
            color: #000000;
        }
         .MuiTableSortLabel-icon {
            opacity: 1;
            color: #000000;
            font-size:20px;
        }
     }
  }
    tbody{
                  border: 1px solid #1B4A83;
border-radius: 0px 0px 5px 5px;
border-bottom: 2px solid #1B4A83;
      td{
        
          text-align: start;
      }
      .countryrow
        {
            font-weight:600;
        }
  }

    }
}
}
.priceCalculation{
    margin-top: 30px;

    .countryTable{
        padding: 30px;
        table
        {
        minwidth:400px;
         thead{
     background-color: #BDD0E9;
     border-bottom:2px solid #1B4A83;
     tr{
         th{
             color: #000000;
             font-weight: 600;
         }
     }
  }
  tbody{
                  border: 1px solid #1B4A83;
border-radius: 0px 0px 5px 5px;
border-bottom: 2px solid #1B4A83;
      td{
          text-align: start;
      }
  }}
    }
    .calculationContainer{
        h4{
            font-size: 20px;
            color: #1B4A83;
            font-weight: 600;
            text-align: start;
            padding-bottom: 10px;
    
            span{
                font-weight: 400; 
            }
        }
        .calculationContent{
            background-color: #fff;
            border-radius: 5px;
            border: 1px solid #1B4A83;
            .d-flex{
                padding: 18px 51px;
                align-items:left;
                gap: 90px;
                .heading{
    h6{
    
        font-size: 18px;
        color: #1B4A83;
        text-align: start;
    
    
    }
    .pricing
        {
            display: flex;
             width: 100%;
              alignItems: flex-start;
               fontWeight: bold;
               span
               {
                margin-left:0px;
                font-weight:600;
               }
        }
    
    span{
        color: #2A2725;
        font-size: 18px;
        font-weight: 500;
    
    }
                }
            }
        }
    }
}
.Note{
    margin-top: 30px;
    .noteTable{
padding: 30px;
.searchInput{
    h5{
        color: #1B4A83;
            padding: 0 20px 0 0;    
    }
        display: flex;
    align-items: center;
    padding-bottom: 5px;
}table
        { minwidth:400px;
            thead{
           background-color: #BDD0E9;
           tr{
               th{

                   font-weight: 600;
               }
           }
        }
        tbody{
            border: 1px solid #1B4A83;
border-radius: 0px 0px 5px 5px;
border-bottom: 2px solid #1B4A83;
        }
    }
}
}
}

}
.distribution {
      margin-top: 30px;
      
      table {
        border-radius: 5px;
      border:1px solid rgb(27, 74, 131);
        padding: 30px;
        thead {
          background-color:#1B4A83;
          tr {
            th {
              color: #FFFFFF;
              font-weight: 600;
            }
          }
          .css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon {
            opacity: 1;
            color: #fff;
        }
         .MuiTableSortLabel-icon {
            opacity: 1;
            color:white;
            font-size:20px;
        }
        }
        tbody {
          border: 1px solid #1b4a83;
          border-radius: 0px 0px 5px 5px;
          border-bottom: 2px solid #1b4a83;
          td {
            text-align: start;
          }
        }
      }
    }

    .viewTableContainer {
    .d-flex {
      justify-content: space-between;

      h4 {
        color: #1b4a83;
        font-size: 20px;
        font-weight: 600;
        font-family: "Noto Sans", sans-serif;
      }
      button {
        text-transform: capitalize;
        border-radius: 5px;
        font-family: "Noto Sans", sans-serif;
        svg {
          padding-right: 6px;
          font-size: 15px;
        }
      }
      .editBtn {
        button {
          font-family: "Noto Sans", sans-serif;
          background-color: #1b4a83;  
          margin: 5px;
        }
      }
      .buttonAlign {
        button {            
          margin: 5px;
        }
      }
    }
  }

`;

